<template>
  <div class="act-page-left">
    <div class="menu-list">
      <div class="item" v-for="(item,index) in menuList"
           :index="index"
           :key="item.id"
      >
        <div class="menu-title">
          <template v-if="index === 0">
            <span class="icon iconfont icon-zhanghuguanli"></span>
          </template>
          <template v-else-if="index === 1">
            <span class="icon iconfont icon-yuedujilu"></span>

          </template>
          <template v-else>
            <span class="icon iconfont icon-zhanghuguanli2"></span>
          </template>
          {{item.label}}
        </div>
        <div class="menu-child">
          <div class="l-item" v-for="(litem,i) of item.children2"
               :index="i"
               :key="litem.id"
          >
            <template v-if="litem.href">
              <router-link :to='litem.href'>{{litem.label}}</router-link>
            </template>
            <template v-else>
              {{litem.label}}
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountLeft",
  data(){
    return {
      menuList:[
        { 
          id:1,
          label:'My account',
          children2:[
            {id:'01',label:'Personal Information',href:'/account'}
          ],
        },
        {
          id:2,
          label:'My Reading',
          children2:[
            {id:'01',label:'My bookshelf',href:'/bookshelf'},
            {id:'02',label:'My footprint',href:'/footprint'},
            // {id:'03',label:'我的借阅',href:'/bookjy'},
          ],
        },
      ],
    }
  },
  mounted: function () {
    if(this.http.GetOrgInfo().LoginMode == 1) {
      this.menuList[0].children2.push({id:'02',label:'Change password',href:'/cipher'});
    }
  },
}
</script>

<style scoped>
  .act-page-left{
    float: left;
    width: 230px;
    background: #fff;
  }
  .act-page-left .menu-title{
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    padding-left: 25px;
    font-size: 18px;
  }
  .act-page-left .menu-title .icon{
    position: relative;
    top:2px;
    color:#999;
    font-size: 24px;
    padding-right: 5px;
  }
  .menu-list .item:nth-child(2) .icon{
    top:1px;
    font-size: 20px;
  }
  .menu-child .l-item{
    height: 50px;
    line-height: 50px;
    border-bottom:1px solid #eee;
    padding-left: 60px;
    font-size: 16px;
    cursor: pointer;
  }
  .menu-child .l-item a{
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/common/other/AccountLeft.vue